import { render, staticRenderFns } from "./ExamDetail.vue?vue&type=template&id=7cb0f4b2&scoped=true&"
import script from "./ExamDetail.vue?vue&type=script&lang=ts&"
export * from "./ExamDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ExamDetail.vue?vue&type=style&index=0&id=7cb0f4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb0f4b2",
  null
  
)

export default component.exports